import React, { Component } from 'react';
import * as enums from '../../../utils/enums';
import { Inventory } from 'travco-input-number';
import { TravcoSingleOptionSelector } from 'travco-single-option-selector';
import { TravcoFieldLabel } from 'travco-field-label';

export default class AllocationComponent extends Component {
    render() {
        let allocationOptions = [
            {
                id: 2,
                label: 'Close',
                selected: this.props.model.allocation ? this.props.model.allocation.status === enums.CLOSED || this.props.model.allocation.count === 'C': true
            }
        ];

        let totalLoaded = this.props.model.allocationRooms ? this.props.model.allocationRooms.reduce((prev, current) => prev + Number(current.allotment), 0) : 999;
        let maxAllocation = totalLoaded < 0 ? 0 : enums.OPEN_ALLOCATION_FREESALE_MAX;
        return (
            <div>
                <div style={{ marginTop: '32px' }}>
                    <TravcoFieldLabel>
                        <input
                            type="checkbox"
                            name="allocationHide"
                            id="ts-f-allocation-hide"
                            checked={this.props.model.allocationActive}
                            onChange={this.props.onCheckboxChange.bind(this, 'allocationHideClick')}
                            disabled={this.props.isNotTravcoUser}
                        />{' '}
                        Maximum Allocation
                    </TravcoFieldLabel>
                </div>

                <div className="travco-rooms-display">
                    <div className="trd-item trd-rooms">
                        {this.props.model.allocationRooms.map((room) => {
                            return (
                                <Inventory
                                    className={'roomType ' + room.name.toLowerCase()}
                                    key={`alloc-${room.id}`}
                                    label={room.name}
                                    min={0}
                                    max={enums.MAX_ROOM_ALLOCATION}
                                    controls
                                    value={room.allotment < 0 ? 0 : room.allotment}
                                    onChange={this.props.onRoomTypeMaxAllotmentChange.bind(this, true, room)}
                                    disabled={!this.props.model.allocationActive}
                                />
                            );
                        })}
                    </div>
                    <div className="trd-item trd-totals">
                        <Inventory
                            className="allocation"
                            label="Total Allocation"
                            key="total-allocation"
                            min={enums.OPEN_ALLOCATION_FREESALE_MIN}
                            max={maxAllocation}
                            controls
                            value={this.props.model.allocation ? this.props.model.allocation.count : 0}
                            onChange={this.props.onConfigurationOptionChange.bind(this, 'count')}
                            disabled={
                                !this.props.model.allocationActive ||
                                (this.props.model.allocation
                                    ? this.props.model.allocation.status === enums.CLOSED || this.props.model.allocation.count === 'C'
                                    : true)
                            }
                        />

                        <Inventory
                            className="allocation-release-days"
                            label="Release Days"
                            key="allocation-release"
                            min={enums.OPEN_ALLOCATION_FREESALE_MIN}
                            max={99}
                            controls
                            value={this.props.model.allocation ? this.props.model.allocation.releaseDays : 0}
                            onChange={this.props.onConfigurationOptionChange.bind(this, 'releaseDays')}
                            disabled={
                                !this.props.model.allocationActive ||
                                (this.props.model.allocation
                                    ? this.props.model.allocation.status === enums.CLOSED || this.props.model.allocation.releaseDays === 'C'
                                    : true)
                            }
                        />
                    </div>
                    <div className="trd-item trd-controls">
                        <TravcoSingleOptionSelector
                            className="rate-calculation"
                            values={allocationOptions}
                            onClick={this.props.onAllocationStatusChange.bind(this)}
                            id="free-nights-rate-calculation"
                            disabled={!this.props.model.allocationActive}
                            btnClassNameActive="btn-danger"
                        />
                    </div>
                </div>
            </div>
        );
    }
}
